import { alpha } from '@mui/material/styles';

const NOTE_BORDER_ALPHA = 0.4;
const NOTE_BG_ALPHA = 0.08;

export const layoutStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  maxWidth: '760px',
};

export const headerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const subtitleStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '20px 24px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const cardTitleStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const cardHintStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const summaryRowsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const summaryRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
};

export const summaryLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const attestationItemStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '12px 14px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
};

export const attestationDescriptionStyles = {
  color: ({ palette }) => palette.text.secondary,
  paddingLeft: '30px',
};

export const getStatusNoteStyles = isError => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '12px 14px',
  borderRadius: '8px',
  border: ({ palette }) =>
    `1px solid ${alpha(isError ? palette.error.main : palette.warning.main, NOTE_BORDER_ALPHA)}`,
  backgroundColor: ({ palette }) =>
    alpha(isError ? palette.error.main : palette.warning.main, NOTE_BG_ALPHA),
  color: ({ palette }) => (isError ? palette.error.main : palette.warning.main),
});

export const statusNoteIconStyles = {
  display: 'flex',
  flexShrink: 0,
  marginTop: '1px',
};
